import { Button, Typography, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import DeleteOutlineOutlined from 'components/material-symbol/icons/DeleteOutline'
import { DetailSection } from 'pages/pga-coach/students/student-show-page/details-components/content-box'
import DeleteFacilityDialog from 'pages/pga-coach/facilities/delete-facility-dialog'

const useStyles = makeStyles(theme => ({
  deleteFacility: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
    },
  },
  deleteText: {
    maxWidth: '60%',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#6B7C87',
    textAlign: 'left',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  deleteActionButton: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    width: 'auto',
    minWidth: 'auto',
    maxWidth: 'none',
    height: 'auto',
    minHeight: 36,
    maxHeight: 'none',
    padding: '6px 16px',
    fontWeight: 600,
    flexShrink: 0,
  },
}))

export default function DeleteFacilitySection({
  facilityId,
  onSuccess,
  disabled = false,
}) {
  const classes = useStyles()

  return (
    <DetailSection title="Delete facility" layout="plain" compact>
      <Box className={classes.deleteFacility}>
        <Typography className={classes.deleteText}>
          Delete facility and all booking types and availability associated to
          this facility. When deleted, this facility will also be removed from
          your coach profile.
        </Typography>
        <DeleteFacilityDialog
          facilityId={facilityId}
          onSuccess={onSuccess}
          trigger={
            <Button
              startIcon={<DeleteOutlineOutlined />}
              variant="outlined"
              color="primary"
              className={classes.deleteActionButton}
              disabled={disabled}
              data-testid="delete-facility-button"
            >
              Delete
            </Button>
          }
        />
      </Box>
    </DetailSection>
  )
}
